import { deriveOutboundFromRide } from './deriveOutboundFromRide';

/**
 * Shape of the draft that `ParallelRideStep` and `ParallelRideWithCushionStep`
 * emit when the dispatcher picks a parallel ride.
 *
 * Legacy `parallelRideId` stays for `buildSubmitPayload` and `validate`. The
 * denormalized `parallelRide` full object feeds Summary so it can render the
 * ride's route and departure without a second lookup.
 *
 * @typedef {object} ParallelRideDraft
 * @property {string | null} parallelRideId
 * @property {object | null} parallelRide Full ride object as returned by the picker.
 * @property {{ fromTimestamp: string, toTimestamp: string } | null} outboundTraveling
 *   Derived from the ride's first-station departure and last-station arrival.
 *   Null when the ride is cleared.
 */

/**
 * @param {string | null} nextId
 * @param {object | null | undefined} ride
 * @param {string | null | undefined} incidentTimestamp UTC ISO timestamp of the breakdown
 * @returns {ParallelRideDraft}
 */
export const buildParallelRideDraft = (nextId, ride, incidentTimestamp) => ({
	parallelRideId: nextId,
	parallelRide: ride ?? null,
	outboundTraveling: deriveOutboundFromRide(ride, incidentTimestamp),
});
